import AutoCellRenderer from './AutoCellRenderer';
import ActionCellRenderer from './ActionCellRenderer';
import AutoIndexCellRenderer from './AutoIndexCellRenderer';
import AvatarCellRenderer from './AvatarCellRenderer';
import DateCellRenderer from './DateCellRenderer';
import EnumCellRenderer from './EnumCellRenderer';
import MultiValueCellRenderer from './MultiValueCellRenderer';
import NumberCellRenderer from './NumberCellRenderer';
import NumericCellRenderer from './NumericCellRenderer';
import ProgressCellRenderer from './ProgressCellRenderer';
import StatusCellRenderer from './StatusCellRenderer';
import TextCellRenderer from './TextCellRenderer';
import UploadCellRenderer from './UploadCellRenderer';

export {
  AutoCellRenderer,
  ActionCellRenderer,
  AutoIndexCellRenderer,
  AvatarCellRenderer,
  DateCellRenderer,
  EnumCellRenderer,
  MultiValueCellRenderer,
  NumberCellRenderer,
  NumericCellRenderer,
  ProgressCellRenderer,
  StatusCellRenderer,
  TextCellRenderer,
  UploadCellRenderer,
};

export const cellRenderMapping = {
  AutoCellRenderer,
  ActionCellRenderer,
  AutoIndexCellRenderer,
  AvatarCellRenderer,
  DateCellRenderer,
  EnumCellRenderer,
  MultiValueCellRenderer,
  NumberCellRenderer,
  NumericCellRenderer,
  ProgressCellRenderer,
  StatusCellRenderer,
  TextCellRenderer,
  UploadCellRenderer,
};
